<template>
    <footer class="footer">
        <div class="footer__top py-60 py-lg-80">
            <v-container class="container--large">
                <UScrollTop />

                <v-row>
                    <v-col cols="12" lg="4">
                        <div class="footer-logo mb-20 mb-lg-40"></div>
                        <div class="d-flex">
                            <a href="https://blog.naver.com/uthestar" target="_blank" class="footer-sns footer-sns__blog mr-6 mr-lg-12"></a>
                            <a href="https://www.instagram.com/uthestarsports/" target="_blank" class="footer-sns footer-sns__instar"></a>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="8">
                        <p class="color-grey">
                            <strong class="font-weight-bold">재단법인 유더스타스포츠</strong><br />
                            Address. 서울특별시 강서구 공항대로 39길 7(구. 등촌동 669-2)<span class="d-none d-xl-inline-block text-center" style="width: 36px; color: #ddd">l</span><br class="d-block d-xl-none" />
                            Tel. 02-3662-3210<span class="d-none d-xl-inline-block text-center" style="width: 36px; color: #ddd">l</span><br class="d-block d-xl-none" />
                            Fax. 02-3664-2401<br />
                            사업자등록번호. 867-82-00369<span class="d-none d-xl-inline-block text-center" style="width: 36px; color: #ddd">l</span><br class="d-block d-xl-none" />
                            개인정보책임자. maruyou@uthestar.org
                        </p>
                        <div class="d-flex mx-n4 mx-lg-n6 pt-14 pt-lg-32 footer-cert-group">
                            <div class="px-4 px-lg-6">
                                <img src="/images/common/cert1.jpg" alt="" class="d-block" />
                            </div>
                            <div class="px-4 px-lg-6">
                                <img src="/images/common/cert2.jpg" alt="" class="d-block" />
                            </div>
                            <div class="px-4 px-lg-6">
                                <img src="/images/common/cert3.jpg" alt="" class="d-block" />
                            </div>
                        </div>
                        <div class="d-flex pt-12 pt-lg-20 footer-org-group">
                            <v-btn href="https://www.acrc.go.kr" target="_blank" tile depressed height="68" class="footer-org">
                                <img src="/images/common/logo-acrc.png" alt="국민권익위원회" class="d-block" />
                            </v-btn>
                            <v-btn href="https://www.nts.go.kr" target="_blank" tile depressed height="68" class="footer-org">
                                <img src="/images/common/logo-nts.png" alt="국세청" class="d-block" />
                            </v-btn>
                            <v-btn href="https://www.seoul.go.kr" target="_blank" tile depressed height="68" class="footer-org">
                                <img src="/images/common/logo-seoul.png" alt="서울특별시" class="d-block" />
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div class="footer__bottom py-22">
            <v-container class="container--large">
                <v-row>
                    <v-col cols="12" lg="4">
                        <div class="d-flex align-center">
                            <a href="/about/business" class="d-block font-weight-bold color-grey mr-10 mr-lg-18">재단 소개</a>
                            <span style="color: #ddd">l</span>
                            <a href="/privacy-policy" class="d-block font-weight-bold color-grey ml-10 ml-lg-18">개인정보처리방침</a>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="8">
                        <p class="color-grey-9">Copyright 2022. 재단법인 유더스타스포츠. all rights reserced.</p>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </footer>
</template>

<script>
import UScrollTop from "@/components/dumb/u-scroll-top.vue";
export default {
    components: {
        UScrollTop,
    },
};
</script>

<style lang="scss" scoped>
/* Footer */
.footer {
    border-top: 6px solid var(--v-secondary-base);
    font-size: 16px;

    &__top {
        border-bottom: 1px solid #e6e6e6;

        .container {
            position: relative;
        }

        p {
            line-height: 30px;
        }
    }
}

.footer-logo {
    width: 261px;
    height: 40px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(/images/footer-ci.png);
}

.footer-sns {
    display: block;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #f7f8f9;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

    &__blog {
        background-image: url(/images/icon/icon-blog.png);
    }

    &__instar {
        background-image: url(/images/icon/icon-instar.png);
    }
}

.footer-cert-group img {
    width: 102px;
}

.footer-org-group {
    gap: 12px;
}

.footer-org.v-btn {
    flex: 1 1 0;
    min-width: 0;
    padding: 0 8px;
    background-color: #fff !important;
    border: 1px solid #ddd;

    &::before {
        display: none;
    }

    img {
        max-width: 100%;
        max-height: 46px;
    }
}

@media (max-width: 1024px) {
    .footer {
        border-top: 3px solid var(--v-secondary-base);
        font-size: 14px;

        &__top p {
            line-height: 24px;
        }
    }

    .footer-logo {
        width: 230px;
        height: 35px;
    }

    .footer-sns {
        width: 40px;
        height: 40px;
    }
}

@media (max-width: 768px) {
    .footer-org-group {
        flex-direction: column;
    }

    .footer-org.v-btn {
        flex: none;
        width: 100%;
    }
}
</style>
